import type { IExercise } from '../exercises';

export const HOME_EPISODE_03_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-home-03-01",
    "name": "世界最伟大拉伸",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 2,
    "reps": "每侧5",
    "rpe": 3,
    "restSeconds": 20,
    "isBodyweight": true,
    "isStretch": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["目标拉伸肌群"],
    "demoUrl": "/media/collections-20261008/demos/mobile-90f9f70a3515a2aa9d32bd43.mp4",
    "videoUrl": "/media/collections-20261008/videos/e52f617bcbac80059d70b908.mp4",
    "source": "居家训练 · 第3期",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-03-02",
    "name": "侧支撑",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["上侧腿搭在稳定支撑物上，侧卧肘支撑", "按教学完成哥本哈根侧支撑"],
    "sets": 3,
    "reps": "每侧30秒",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["髋内收肌群", "核心肌群"],
    "demoUrl": "/media/collections-20261008/demos/mobile-b89db0cda47a94d5ec4a9a79.mp4",
    "videoUrl": "/media/collections-20261008/videos/6bc0308f47c467bd9d581f58.mp4",
    "source": "居家训练 · 第3期",
    "isWarmup": true,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-03-03",
    "name": "高脚杯深蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "quadriceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["股四头肌", "臀大肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-1bb727d4c8c33e62e2f438dd.mp4",
    "videoUrl": "/media/collections-20261008/videos/aba4b298bab7cc439297284c.mp4",
    "source": "居家训练 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-03-04",
    "name": "保加利亚分腿蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "glutes",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["臀大肌", "腘绳肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-eb6558d1f4c68cdd858bac19.mp4",
    "videoUrl": "/media/collections-20261008/videos/94a0d63c4857526787e17c63.mp4",
    "source": "居家训练 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-03-05",
    "name": "罗马尼亚硬拉",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "hamstrings",
    "tips": ["屈髋主导，感受腘绳肌延展", "腰背全程平直"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "居家训练 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/mobile-cee6960b027ce6857ab633b9.mp4",
    "videoUrl": "/media/collections-20261008/videos/62adb74b3ca25184ff666d77.mp4",
    "targetMuscles": ["腘绳肌", "臀大肌"],
    "difficulty": "advanced",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-03-06",
    "name": "臀桥",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "glutes",
    "tips": ["一腿抬起，支撑腿完成单腿臀桥", "按教学控制骨盆位置与抬起节奏"],
    "sets": 4,
    "reps": "15-20",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["臀大肌", "腘绳肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-058ef64bc975228f1c9251d7.mp4",
    "videoUrl": "/media/collections-20261008/videos/d2483aa74ff47c957568c131.mp4",
    "source": "居家训练 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-03-07",
    "name": "站姿提踵",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "calves",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 4,
    "reps": "15-20",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["腓肠肌", "比目鱼肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-bf170dc536b9eac7947467de.mp4",
    "videoUrl": "/media/collections-20261008/videos/e8ac6153be2dc6ad5e2c9c11.mp4",
    "source": "居家训练 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
